export function getErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    return typeof error === "string" ? error : "Ukjent feil";
}
export function isValidImportId(importId) {
    const trimmed = (importId ?? "").trim();
    if (!trimmed)
        return false;
    if (trimmed.startsWith("MISSING_IMPORT_ID_ROW_"))
        return false;
    return true;
}
export function normalizeImportId(importId) {
    return (importId ?? "").trim();
}
export function isNonEmptyString(v) {
    return typeof v === "string" && v.trim().length > 0;
}
